export function Blinds({ row }) {
  const quizz = row;

  return `$${quizz.blind_small}/$${quizz.blind_big}`;
}
